import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { Fase } from 'src/app/dashboard/models/fase';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FaseService } from 'src/app/dashboard/services/fase.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-show-phase',
  templateUrl: './show-phase.component.html',
  styleUrls: ['./show-phase.component.css']
})
export class ShowPhaseComponent implements OnInit {
  sociedad: string;
  fases: Fase[];
  allFases: Fase[] = [];
  validatingForm: FormGroup;
  currentPage = 1;
  pageSize = 10;
  totalItems = 0;
  IsHiddenForm = false;

  constructor(
    private faseService: FaseService,
    private apiService: ApiService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private changeDetectorRefs: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);
    this.sociedad = this.auth.getNameSociedad();

    this.loadPhases();

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        Validators.pattern(/^(?!.*(<|>|script|on\w+=|javascript:|data:text\/html|base64)).*$/i),
        CustomValidators.secureInput
      ])
    });
  }

  loadPhases() {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.faseService.searchPhaseByUser(this.auth.getSociedad(), language).subscribe((phases: Fase[]) => {
      this.fases = phases;
      this.allFases = phases;
      this.totalItems = phases.length;
      this.updateCurrentPagePhases();
    });
  }

  updateCurrentPagePhases() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.fases = this.allFases.slice(startIndex, startIndex + this.pageSize);
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadPhases();
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  updatePhase(idFase: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    const name = this.signupFormModalName.value.trim();
    const commentary = this.contactFormModalMessage.value?.trim() || 'Sin comentarios';
    const id = this.signupFormModalId.value;

    this.faseService.updatePhaseByUser(this.auth.getSociedad(), id, name, language, commentary).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_708'), this.translate.instant('texto_710'));
        } else {
          this.toastr.error(this.translate.instant('texto_709'), this.translate.instant('texto_710'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/phases']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_709'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_709'), this.translate.instant('texto_813'));
        }
      });
  }

  showCenter(phase: Fase) {
    this.IsHiddenForm = true;
    this.validatingForm.patchValue({
      signupFormModalId: phase.id_fase,
      signupFormModalName: phase.n_fase,
      contactFormModalMessage: phase.comentario
    });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }
}
